import { Chip, DialogContent } from '@/core/ui';
import { lighten, styled } from '@mui/material';
export const DialogContentStyled = styled(DialogContent)({
    paddingBottom: '2rem',
});
export const QuantityChipRevokable = styled(Chip)(({ theme, color }) => ({
    gap: '.25rem',
    backgroundColor: color === 'success'
        ? lighten(theme.palette.success.lightest, 0)
        : color === 'warning'
            ? lighten(theme.palette.warning.lightest, 0.1)
            : color === 'yellow'
                ? lighten(theme.palette.yellow.lightest, 0.1)
                : color === 'error'
                    ? lighten(theme.palette.error.lightest, 0.2)
                    : color,
    '.MuiChip-label': {
        lineHeight: '1rem',
        fontSize: theme.typography.caption.fontSize,
        minWidth: '1.75rem',
        // If table cell has align left then the label inherits this align, should be fixed to right, near the x button.
        textAlign: 'right',
    },
}));
